var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",class:{ 'loader-absolute': _vm.absolute },style:(`background: ${_vm.overlayBackground}`)},[_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":_vm.indeterminate,"size":_vm.size,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }